import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: [],
    item: null
  },

  getters: {
    currentProfile: (state) => state.item
  },

  mutations: {
    profileFetched(state, { profile }) {
      state.item = profile
    },

    profileUpdated(state, { profile }) {
      state.item = profile
    },

    resetState(state) {
      state.list = []
      state.item = null
    }
  },

  actions: {
    fetchProfile({ commit }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/profile`
        })
          .then((response) => {
            deserialize(response.data).then((profile) => {
              commit('profileFetched', { profile })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    },

    updateProfile({ commit, state }, changes) {
      return new Promise((resolve, reject) => {
        update({
          url: `/api/profile`,
          type: 'profile',
          changes,
          record: state.item
        })
          .then((response) => {
            deserialize(response.data).then((profile) => {
              commit('profileUpdated', { profile })
              resolve()
            })
          })
          .catch(({ response }) => {
            reject(new FormErrors(response.data.errors))
          })
      })
    }
  }
}
